'use client'

import { LuArrowLeft, LuArrowRight } from 'react-icons/lu'
import { Box, Flex, Text } from '@chakra-ui/react'
import Image from 'next/image'

import Container from 'app/components/shared/Container'
import { SectionHeading } from 'app/components/shared/Text/SectionHeading'
import { useSlider } from 'utils/useSlider'

import { ArrowButton, AuthorButton, AuthorPhoto, AuthorsWrapper, Slide, StyledSlider } from './styles'
import { Testimonial } from '.'

type Props = {
  heading: string
  testimonials: Testimonial[]
}

const TestimonialsClient = ({ heading, testimonials }: Props): JSX.Element => {
  const { handleSlideSelect, handlePreviousSlide, handleNextSlide, touchHandlers, selectedSlide } = useSlider({
    slides: testimonials,
  })

  return (
    <Box marginTop={{ base: '72px', lg: '160px' }}>
      <Container>
        <Flex direction={{ base: 'column', lg: 'row' }}>
          <Box width={{ lg: '30%' }}>
            <SectionHeading>{heading}</SectionHeading>
          </Box>
          <Box
            marginY={{ base: '28px', lg: 0 }}
            width={{ lg: '18%' }}
            display={{ lg: 'flex' }}
            justifyContent="flex-end"
            alignItems="flex-start"
            paddingRight={{ lg: '20px' }}
          >
            <Image src="/icons/quote.svg" alt="Quote image" width={64} height={45} />
            {/* <img loading="lazy" src="/icons/quote.svg" alt="" /> */}
          </Box>
          <StyledSlider {...touchHandlers}>
            {testimonials.map((testimonial, index) => (
              <Slide
                key={index}
                isActive={selectedSlide === index}
                isPrevious={selectedSlide - 1 >= index}
                isNext={selectedSlide + 1 <= index}
              >
                <Text fontSize="md">{testimonial.quote}</Text>
              </Slide>
            ))}
          </StyledSlider>
        </Flex>
      </Container>

      <Flex>
        <Box
          display={{ base: 'none', lg: 'block' }}
          width="48%"
          paddingLeft={{ lg: '20px', xl: 'calc((100% - 1320px) / 2)' }}
          marginTop="50px"
        >
          <ArrowButton onClick={handlePreviousSlide} isDisabled={selectedSlide === 0} aria-label="Previous slide">
            <LuArrowLeft size={42} strokeWidth={1} />
          </ArrowButton>
          <Box marginLeft="25px" display="inline">
            <ArrowButton
              onClick={handleNextSlide}
              isDisabled={selectedSlide === testimonials.length - 1}
              aria-label="Next slide"
            >
              <LuArrowRight size={42} strokeWidth={1} />
            </ArrowButton>
          </Box>
        </Box>
        <AuthorsWrapper>
          {testimonials.map((testimonial, index) => (
            <AuthorButton
              isCurrentlyVisible={selectedSlide === index}
              key={index}
              onClick={() => handleSlideSelect(index)}
              aria-label="Click to see next author"
            >
              <AuthorPhoto isCurrentlyVisible={selectedSlide === index} src="./icons/circle-star.svg" alt="" />

              {selectedSlide === index && (
                <Text fontSize="sm" marginLeft="20px">
                  {testimonial.author}
                </Text>
              )}
            </AuthorButton>
          ))}
        </AuthorsWrapper>
      </Flex>
    </Box>
  )
}

export default TestimonialsClient
